import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-galerie-part',
  templateUrl: './galerie-part.component.html',
  styleUrls: ['./galerie-part.component.css']
})
export class GaleriePartComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
